import type { Ref, TextareaHTMLAttributes } from "react";
import "./text-field.css";

type Props = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "id" | "aria-invalid" | "aria-describedby"> & {
  id: string;
  label: string;
  /** Una spiegazione che resta scritta sotto il campo e legata al campo, come in TextField. */
  hint?: string;
  error?: string;
  className?: string;
  ref?: Ref<HTMLTextAreaElement>;
};

// TextField su più righe, per un testo libero lungo come una descrizione (UX_SYSTEM, decisione del 1° ottobre
// 2026): stesse etichetta, aiuto e semantica d'errore, che le prop native non possono sovrascrivere.
export function TextArea({ id, label, hint, error, className, rows = 3, ...rest }: Props) {
  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;
  const describedBy = [hint ? hintId : null, error ? errorId : null].filter(Boolean).join(" ");
  const classes = className ? `g-field__input g-field__input--multiline ${className}` : "g-field__input g-field__input--multiline";
  return (
    <div className="g-field">
      <label className="g-field__label" htmlFor={id}>{label}</label>
      <textarea
        id={id}
        rows={rows}
        {...rest}
        className={classes}
        aria-invalid={error ? "true" : undefined}
        aria-describedby={describedBy || undefined}
      />
      {hint ? <p id={hintId} className="g-field__hint">{hint}</p> : null}
      {error ? <p id={errorId} className="g-field__error" role="alert">{error}</p> : null}
    </div>
  );
}
